import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import Image from 'next/image';

export default function RelatedServices ({ services }) {
  const { t } = useTranslation('common');

  return (
    <div className={'related-services'}>
      <h2>{t('related_services')}</h2>
      <div className={'related-services__list'}>
        {
          services.map((service, index) => (
            <Link key={index} href={service.link}>
              <a>
                <div className={'related-services__item'}>
                  <div className={'related-services__img-container'}>
                    <Image src={service.img} alt="" aria-hidden="true" />
                  </div>
                  <p>{t(service.title)}</p>
                </div>
              </a>
            </Link>
          ))
        }
      </div>
    </div>
	);
};
